<div class="location-select-container">
    <div class="select-box">
        <div *ngIf="showLabel">Lab</div>
        <nz-select [(ngModel)]="selectLab" class="type-select" (ngModelChange)="changeLab()" [nzAllowClear]="true">
            <nz-option *ngFor="let option of labOptions" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
        </nz-select>
    </div>


    <div class="select-box">
        <div *ngIf="showLabel">Floor</div>
        <nz-select [nzLoading]="selectFloorLoading" [(ngModel)]="selectFloor" class="type-select"
                   (ngModelChange)="changeFloor()" [nzAllowClear]="true">
            <nz-option *ngFor="let option of floorOptions" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
        </nz-select>
    </div>

    <div class="select-box">
        <div *ngIf="showLabel">Room</div>
        <nz-select [nzLoading]="selectRoomLoading" [(ngModel)]="selectRoom" class="type-select"
                   (ngModelChange)="changRoom()" [nzAllowClear]="true">
            <nz-option *ngFor="let option of roomOptions" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
        </nz-select>
    </div>
</div>
